var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CrudTable',_vm._b({attrs:{"storeModule":_vm.storeModule,"showActionsPanel":false,"addItems":false},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'ProductCategoryDetail', params: { id: item.id }}}},[_vm._v(" "+_vm._s(item.name ? item.name : '-')+" ")])]}}])},'CrudTable',_vm.crudTableConfig,false))}
var staticRenderFns = []

export { render, staticRenderFns }